import '@fortawesome/fontawesome-free/css/all.css'
import { initializeProgrammingView } from './programming'

import '../common/css/tab.css'
import '../common/css/visually_impaired.css'
import './polyfills'
import app from './app.html'
import { initializeLanguage } from './common/language'
if (process.env.WATCH) {
  new EventSource('/esbuild').addEventListener('change', () => location.reload())
}

/* eslint-disable-next-line @typescript-eslint/no-misused-promises */
window.addEventListener('load', async () => {
  document.querySelector('#main').innerHTML = app

  if (process.env.ENABLE_WEBDAV) {
    const args = new URLSearchParams(window.location.search)
    window.path = `/wd/${encodeURIComponent(args.get('filename'))}`
  }

  initializeLanguage()
  const loadingScreen = document.getElementById('loading')
  loadingScreen.classList.remove('hidden')

  await initializeProgrammingView()

  loadingScreen.classList.add('hidden')
})
